<template>
  <section class="double-col">
    <div class="c-container">
      <AppTextBlock
        class="double-col__content"
        v-if="data.content !== undefined"
        :data="data.content"
      />
    </div>
  </section>
</template>

<script>
import AppTextBlock from '@/components/AppTextBlock.vue';

export default {
  name: 'DoubleColumn',

  components: {
    AppTextBlock,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/variables';

.double-col .double-col__content::v-deep p {
  @include mq(ipadP) {
    column-count: 2;
    column-rule: 1px solid #dedede;
    column-gap: 100px;
    padding: 40px;
  }
}
</style>
